import axios from 'axios';

import { BASE_APP_URL, DEFAULT_HEADERS } from 'constants/url';

export const GET = 'get';
export const POST = 'post';
export const PUT = 'put';
export const PATCH = 'patch';
export const DELETE = 'delete';

const Agent = (config = { baseURL: BASE_APP_URL }) => {
  const _agent = axios.create(config);

  return _agent;
};

export const appRequest = Agent();
export const authRequest = Agent({
  baseURL: BASE_APP_URL,
  headers: DEFAULT_HEADERS,
  withCredentials: true,
});
export const traefikRequest = Agent({
  baseURL: process.env.REACT_APP_TRAEFIK_URL,
});

export default appRequest;
